import React from "react";
import MetaTags from "react-meta-tags";
import { Link, Redirect, useParams } from "react-router-dom";
import { HiOutlineAcademicCap, HiOutlineArrowLeft, HiOutlineUserGroup } from "react-icons/hi2";
import {
  getBunditRound,
  isBunditRoundId,
} from "../config/admissionRound";
import imgDoctor from "../assets/2027/bundit/bundit_ll.png";
import imgMaster from "../assets/2027/bundit/bundit_l.png";
import "./Register.css";
import "../Components/RegisterRounds/RegisterRounds.css";

const base = process.env.REACT_APP_BASENAME || "";

/**
 * สเต็ป 2 — เลือกระดับหลังเลือกรอบแล้ว
 * URL: /select-bundit/:robId
 * → /Register/3?robId=… (โท) หรือ /Register/4?robId=… (เอก)
 */
function Select_bundit_level() {
  const { robId } = useParams();
  const round = getBunditRound(robId);

  if (!isBunditRoundId(robId) || !round) {
    return <Redirect to="/select-bundit" />;
  }

  if (!round.open) {
    return <Redirect to="/select-bundit" />;
  }

  const levelOptions = [
    {
      href: `${base}/Register/3?robId=${encodeURIComponent(robId)}`,
      src: imgMaster,
      alt: "สมัครเรียนระดับปริญญาโท",
      label: "ปริญญาโท",
    },
    {
      href: `${base}/Register/4?robId=${encodeURIComponent(robId)}`,
      src: imgDoctor,
      alt: "สมัครเรียนระดับปริญญาเอก",
      label: "ปริญญาเอก",
    },
  ];

  return (
    <>
      <MetaTags>
        <title>
          เลือกระดับ · {round.label} | มหาวิทยาลัยราชภัฏกำแพงเพชร
        </title>
        <meta
          name="description"
          content={`เลือกระดับปริญญาโทหรือปริญญาเอก สำหรับ${round.label}`}
        />
      </MetaTags>

      <div className="reg-page">
        <div className="reg-hero">
          <p className="reg-hero__eyebrow">มหาวิทยาลัยราชภัฏกำแพงเพชร</p>
          <h1 className="reg-hero__title">
            <HiOutlineAcademicCap size={28} aria-hidden />
            เลือกระดับที่ต้องการสมัคร
          </h1>
          <p className="reg-hero__desc">
            รอบที่เลือก: <strong>{round.label}</strong> (ROB {robId})
          </p>
        </div>

        <div className="reg-steps">
          <div className="reg-step is-done">1. เลือกรอบ · {round.label}</div>
          <div className="reg-step is-active">
            <HiOutlineUserGroup size={16} aria-hidden />
            2. เลือกระดับ ป.โท / ป.เอก
          </div>
        </div>

        <p style={{ margin: "0 0 1rem" }}>
          <Link to="/select-bundit" className="reg-back-link">
            <HiOutlineArrowLeft size={16} aria-hidden />
            เปลี่ยนรอบ
          </Link>
        </p>

        <div className="reg-panel">
          <h2 className="reg-panel__title">
            <HiOutlineUserGroup size={20} aria-hidden />
            เลือกรายการที่ต้องการ
          </h2>
          <p className="reg-panel__hint">กดที่ภาพเพื่อเข้าสู่ระบบสมัครเรียน</p>

          <div className="reg-rounds reg-rounds--bundit reg-rounds--banner">
            {levelOptions.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="reg-round reg-round--bundit"
              >
                <img src={item.src} alt={item.alt} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Select_bundit_level;
